/**
 * Modal layer stack — one active scrim, top-only Escape/scrim dismiss, body scroll lock.
 */

let stack = [];
let modalSeq = 0;
let savedBodyOverflow = '';
let savedBodyPaddingRight = '';
let savedBodyPosition = '';
let savedBodyTop = '';
let savedBodyWidth = '';
let lockedScrollY = 0;
let closeTopHandler = null;

function isMobileViewport() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(max-width: 767px)').matches;
}

function lockBody() {
  if (stack.length !== 1) return;

  // iOS Safari: overflow:hidden on body breaks keyboard focus inside fixed modals.
  if (isMobileViewport()) return;

  lockedScrollY = window.scrollY || 0;
  savedBodyOverflow = document.body.style.overflow;
  savedBodyPaddingRight = document.body.style.paddingRight;
  savedBodyPosition = document.body.style.position;
  savedBodyTop = document.body.style.top;
  savedBodyWidth = document.body.style.width;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = 'hidden';
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function unlockBody() {
  if (stack.length !== 0) return;
  document.body.style.overflow = savedBodyOverflow || '';
  document.body.style.paddingRight = savedBodyPaddingRight || '';
  document.body.style.position = savedBodyPosition || '';
  document.body.style.top = savedBodyTop || '';
  document.body.style.width = savedBodyWidth || '';
  if (lockedScrollY) {
    window.scrollTo(0, lockedScrollY);
  }
  lockedScrollY = 0;
}

/** @returns {number} modal id */
export function pushModal(onClose, z = 400) {
  const id = ++modalSeq;
  stack.push({ id, onClose, z });
  lockBody();
  return id;
}

export function popModal(id) {
  stack = stack.filter((entry) => entry.id !== id);
  unlockBody();
}

export function isTopModal(id) {
  if (!id || stack.length === 0) return false;
  return stack[stack.length - 1].id === id;
}

export function getModalStackDepth() {
  return stack.length;
}

/** Close the topmost modal via its registered onClose handler. */
export function closeTopModal() {
  const top = stack[stack.length - 1];
  if (top?.onClose) {
    top.onClose();
    return true;
  }
  if (typeof closeTopHandler === 'function') {
    return closeTopHandler();
  }
  return false;
}

/** @deprecated Lockbox state fallback — prefer Modal stack onClose handlers. */
export function registerLockboxModalCloser(fn) {
  closeTopHandler = fn;
}

export function unregisterLockboxModalCloser(fn) {
  if (closeTopHandler === fn) closeTopHandler = null;
}

/** @deprecated use closeTopModal */
export function closeTopLockboxModal() {
  return closeTopModal();
}

/** @deprecated use pushModal */
export function onModalOpened() {
  pushModal(() => {}, 0);
}

/** @deprecated use popModal */
export function onModalClosed() {
  if (stack.length > 0) {
    popModal(stack[stack.length - 1].id);
  }
}

/** @internal clears stack in unit tests */
export function clearModalStackForTests() {
  stack = [];
  unlockBody();
  savedBodyOverflow = '';
  savedBodyPaddingRight = '';
  savedBodyPosition = '';
  savedBodyTop = '';
  savedBodyWidth = '';
  lockedScrollY = 0;
}
